export default __webpack_public_path__ + "img/MobileScreenshot-2024-08-13.a080ee1f.png";